import { Suspense } from 'react';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { FIELD_OPS_PERMISSIONS } from '@/constants/permissions';
import { z } from 'zod';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { SurveySubmissionsPage } from '@/features/surveys/pages/SurveySubmissionsPage';
import { parsePositiveIdParams } from '@/utils/routeParams';

const positiveIdSchema = z.coerce.number().int().positive().optional().catch(undefined);

export const surveySubmissionsSearchSchema = z.object({
  divisionId: positiveIdSchema,
  districtId: positiveIdSchema,
  thanaId: positiveIdSchema,
  departmentId: positiveIdSchema,
  reportingToId: positiveIdSchema,
  search: z.string().optional().catch(undefined),
});

export type SurveySubmissionsSearch = z.infer<typeof surveySubmissionsSearchSchema>;

export const Route = createFileRoute('/_auth/feedback/surveys/$surveyId/submissions/')({
  beforeLoad: () => requirePermission(FIELD_OPS_PERMISSIONS.SURVEY_VIEW),
  parseParams: (rawParams) => {
    const params = parsePositiveIdParams(rawParams);
    if (params === null) throw notFound();
    return params;
  },
  validateSearch: surveySubmissionsSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Survey Submissions">
      <Suspense fallback={<PageLoader />}>
        <SurveySubmissionsPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
